import { Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  modeSelector,
  profileDetailsSelector,
  quickSearchSelector,
} from "../store/selectors/app.selector";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { setQuickSearch } from "../store/actions/app.action";

export default function QuickSearch() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const QuickSearchValue = useSelector(quickSearchSelector);
  const mode = useSelector(modeSelector);
  const [value, setValue] = useState(QuickSearchValue);
  console.log("{{{{value}}}}", value);
  const profileDetails = useSelector(profileDetailsSelector);

  const handleSearchChange = useCallback((selected) => {
    try {
      dispatch(setQuickSearch(selected));
      //   setValue(QuickSearchValue);
      navigate(selected);
    } catch (error) {}
  }, []);
  const transferOptions = []

  if (profileDetails["retail"] === true || ["I"].includes(mode)) {
    transferOptions.push(
  {
    menuName: "Transfers",
    pathName: "/transfer",
  },
  // {
  //   menuName: "Statement Analyzer",
  //   pathName: "/transfer",
  // },
  
  {
    menuName: "Add Beneficary",
    pathName: "/add-beneficary",
  },

  {
    menuName: "Add Internal Beneficary",
    pathName: "/add-internal-beneficary",
  },
  // {
  //   menuName: "Add Other Beneficary",
  //   pathName: "/add-other-beneficary",
  // },
  // {
  //   menuName: "Add International Beneficary",
  //   pathName: "/add-international-beneficary",
  // },
  // {
  //   menuName: "Add Wallet Beneficary",
  //   pathName: "/add-wallet-beneficary",
  // },
  {
    menuName: "Quick Transfer",
    pathName: "/send-money/quick-pay",
  },

  {
    menuName: "Internal Quick Transfer",
    pathName: "/internal-quick-transfer",
  },
  // {
  //   menuName: "Other Quick Transfer",
  //   pathName: "/other-quick-transfer",
  // },
  // {
  //   menuName: "International Quick Transfer",
  //   pathName: "/international-quick-transfer",
  // },
  // {
  //   menuName: "Wallet Quick Transfer",
  //   pathName: "/wallet-quick-transfer",
  // },

  // {
  //   menuName: "Internal Transfer",
  //   pathName: "/send-money/payee-transfer",
  //   state: { mode: "PAY_LIST" },
  // },

  {
    menuName: "Beneficiary Transfer",
    pathName: "/send-money",
  },
  {
    menuName: "Manage Beneficiary",
    pathName: "/send-money/manage-beneficiary",
  },
  {
    menuName: "View Scheduled Transactions",
    pathName: "/send-money/scheduled",
  },
  {
    menuName: "Transaction History",
    pathName: "/send-money/history",
  },
  {
    menuName: "Link Account",
    pathName: "/settings/link-account",
  },
  {
    menuName: "De-Link Account",
    pathName: "/settings/delink-account",
  },
);
}

  const searchOptions = [
    {
      menuName: "Portfolio",
      pathName: "/portfolio",
    },
    {
      menuName: "Accounts",
      pathName: "/accounts",
    },
    // {
    //   menuName: "Add Account",
    //   pathName: "/add-account",
    // },
    // {
    //   menuName: "Open Deposit",
    //   pathName: "/accounts/deposit/open",
    // },
    // {
    //   menuName: "Apply New Loan",
    //   pathName: "/accounts/loan/apply",
    // },
    ...transferOptions, 
    // {
    //   menuName: "Salary Upload",
    //   pathName: "/salary-upload",
    // },
    // {
    //   menuName: "Salary Upload History",
    //   pathName: "/salary-upload/history",
    // },
    // {
    //   menuName: "Bulk Payment",
    //   pathName: "/bulk-payment",
    // },
    // {
    //   menuName: "Withdraw",
    //   pathName: "/cardless-cash",
    // },
    // {
    //   menuName: "Generate Token",
    //   pathName: "/generate-token",
    // },
    // {
    //   menuName: "Payments",
    //   pathName: "/payment",
    // },
    // {
    //   menuName: "Add Biller",
    //   pathName: "/bill-payment/add-biller",
    // },
    // {
    //   menuName: "View Biller Beneficiary",
    //   pathName: "/bill-payment/view-biller",
    // },
    // {
    //   menuName: "Bill Payments",
    //   pathName: "/bill-payment",
    // },
    // {
    //   menuName: "View Scheduled Payments",
    //   pathName: "/scheduled-payments",
    // },
    {
      menuName: "Exchange Rates",
      pathName: "/exchange-rate",
    },
    // {
    //   menuName: "Trade Finance",
    //   pathName: "/trade-finance",
    // },
    // {
    //   menuName: "Government Payment",
    //   pathName: "/government-payment",
    // },

    // {
    //   menuName: "Government Payment History",
    //   pathName: "/government-payment/history",
    // },
    // {
    //   menuName: "Debit Card",
    //   pathName: "/card-settings",
    // },
    // {
    //   menuName: "Debit Card Limit",
    //   pathName: "/card-settings/debit-card/limits",
    // },
    // {
    //   menuName: "Block Debit card",
    //   pathName: "/card-settings/block-debit-card",
    // },
    // {
    //   menuName: "Salary Advance",
    //   pathName: "/salaray-advance",
    // },
    // {
    //   menuName: "Loan Request",
    //   pathName: "/salaray-advance-request",
    // },
    // {
    //   menuName: "Loan Repay",
    //   pathName: "/salaray-advance-repay",
    // },
    {
      menuName: "My Activity",
      pathName: "/myActivity",
    },
    {
      menuName: "Contact Us",
      pathName: "/help",
    },
    {
      menuName: "Profile Details",
      pathName: "/profile",
    },
    // {
    //   menuName: "Manage Username",
    //   pathName: "/manage-userId",
    // },
    {
      menuName: "Change Password",
      pathName: "/change-password",
    },

    // {
    //   menuName: "Service Request",
    //   pathName: "/request",
    // },
    // {
    //   menuName: "Cheque Book Request",
    //   pathName: "/request/cheque-book/request-cheque",
    // },
    // {
    //   menuName: "Standing Instruction",
    //   pathName: "/standing-instruction",
    // },
    // {
    //   menuName: "Create Standing Instruction",
    //   pathName: "/create-standing-instruction",
    // },
    // {
    //   menuName: "Cheque Status",
    //   pathName: "/request/cheque-status",
    // },
    // {
    //   menuName: "Stop Cheque",
    //   pathName: "/request/stop-cheque",
    // },
    // {
    //   menuName: "eStatement Request",
    //   pathName: "/request/eStatement",
    // },

    {
      menuName: "Other Services",
      pathName: "/settings",
    },
    {
      menuName: "Transfer Limit",
      pathName: "/settings/transfer-limit",
    },
    {
      menuName: "Security Questions",
      pathName: "/settings/security",
    },
    {
      menuName: "Set Primary Account",
      pathName: "/settings/primaryAcc",
    },
    
    {
      menuName: "Offers",
      pathName: "/settings/offers",
    },
    {
      menuName: "EMI Calculator",
      pathName: "/settings/emi-calculator",
    },
    {
      menuName: "Locate Branch",
      pathName: "/settings/locate-us",
    },
    {
      menuName: "FAQ",
      pathName: "/settings/faq",
    },
    {
      menuName: "My QR Code",
      pathName: "/settings/qr-code",
    },
    {
      menuName: "Terms And Conditions",
      pathName: "/settings/terms-and-conditions",
    },
    {
      menuName: "About Us",
      pathName: "/settings/about-us",
    },

    // {
    //   menuName: "KYC Update",
    //   pathName: "/kyc-update",
    // },
  ];
  
  if (["A", "VR", "VW"].includes(mode)) {
    searchOptions.push(
      {
        menuName: "Approval",
        pathName: "/pending-authorization",
      },
      {
        menuName: "Beneficiary Pending Approval",
        pathName: "/pending-authorization/beneficiary",
      },
      {
        menuName: "Fund Transfer Pending Approval",
        pathName: "/pending-authorization/ft",
      },
      {
        menuName: "Bulk Payment Upload Pending Approval",
        pathName: "/pending-authorization/bulk-payment-upload",
      },
      {
        menuName: "Salary Upload Pending Approval",
        pathName: "/pending-authorization/salary-upload",
      },
      {
        menuName: "Standing Instructions Pending Approval",
        pathName: "/pending-authorization/standing-instructions",
      },
      {
        menuName: "Biller Beneficiary Pending Approval",
        pathName: "/pending-authorization/biller-bene",
      },
      {
        menuName: "Payments Pending Approval",
        pathName: "/pending-authorization/payments",
      },
      {
        menuName: "Loan Repayment Pending Approval",
        pathName: "/pending-authorization/loan-repayment",
      },
      {
        menuName: "Government Payment Pending Approval",
        pathName: "/pending-authorization/gepg",
      },
      {
        menuName: "History",
        pathName: "/history",
      },

      {
        menuName: "Beneficiary History",
        pathName: "/history/beneficiary",
      },
      {
        menuName: "Fund Transfer History",
        pathName: "/history/ft",
      },
      {
        menuName: "Bulk Payment Upload History",
        pathName: "/history/bulk-payment-upload",
      },
      {
        menuName: "Salary Upload History",
        pathName: "/history/salary-upload",
      },
      {
        menuName: "Standing Instructions History",
        pathName: "/history/si",
      },
      {
        menuName: "Biller Beneficiary History",
        pathName: "/history/biller-bene",
      },
      {
        menuName: "Payments History",
        pathName: "/history/payments",
      },
      {
        menuName: "Loan Repayment History",
        pathName: "/history/loan-repayment",
      },
      {
        menuName: "Government Payment History",
        pathName: "/history/gepg",
      }
    );
  }
  return (
    <div style={{ margin: "0 30px" }} className="d-none d-lg-block">
      <Form autoComplete="off">
      <Form.Item>
      <Select
        showSearch
        placeholder={t("pages.dashboard.quick_search", {
          defaultValue: "Quick Search",
        })}
        optionFilterProp="children"
        style={{ width: 250, marginRight: 50 }}
        value={QuickSearchValue}
        onChange={handleSearchChange}
      >
        {searchOptions.map((option, idx) => (
          <Select.Option key={idx} value={option.pathName}>
            {option.menuName}
          </Select.Option>
        ))}
      </Select>
      </Form.Item>
      </Form>
    </div>
  );
}
